// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SurveySessionValueReadModel {
    static getAttributeTypeMap() {
        return SurveySessionValueReadModel.attributeTypeMap;
    }
}
SurveySessionValueReadModel.discriminator = undefined;
SurveySessionValueReadModel.additionalProperties = false;
SurveySessionValueReadModel.attributeTypeMap = [
    {
        "name": "questionText",
        "baseName": "questionText",
        "type": "string"
    },
    {
        "name": "answerCategoryId",
        "baseName": "answerCategoryId",
        "type": "number"
    },
    {
        "name": "answerCategoryCode",
        "baseName": "answerCategoryCode",
        "type": "string"
    },
    {
        "name": "answerCategoryDescription",
        "baseName": "answerCategoryDescription",
        "type": "string"
    },
    {
        "name": "questionCategories",
        "baseName": "questionCategories",
        "type": ""
    },
    {
        "name": "surveyId",
        "baseName": "surveyId",
        "type": "number"
    },
    {
        "name": "surveyDescription",
        "baseName": "surveyDescription",
        "type": "string"
    },
    {
        "name": "sequenceNum",
        "baseName": "sequenceNum",
        "type": "number"
    },
    {
        "name": "questionType",
        "baseName": "questionType",
        "type": "string"
    },
    {
        "name": "pageTitle",
        "baseName": "pageTitle",
        "type": "string"
    },
    {
        "name": "surveySessionId",
        "baseName": "surveySessionId",
        "type": "number"
    },
    {
        "name": "questionId",
        "baseName": "questionId",
        "type": "number"
    },
    {
        "name": "answerId",
        "baseName": "answerId",
        "type": "number"
    },
    {
        "name": "answerValue",
        "baseName": "answerValue",
        "type": "string"
    },
];
//# sourceMappingURL=surveySessionValueReadModel.js.map